import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import DoctorFormBase from "./DoctorFormBase";
import ResponseMessage from "../common/ResponseMessage";
import type { DoctorFormData } from "../../types";

const DoctorAccountRegistration: React.FC = () => {
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: DoctorFormData) => {
    setIsSubmitting(true);
    setResponseMessage("");
    try {
      const token = localStorage.getItem("token");


      if (!token) throw new Error("Aucun token trouvé. Veuillez vous reconnecter.");




      // Utilisation directe de l'instance axios configurée
      await axiosInstance.post(API_ENDPOINTS.USERS.CREATE, data);



      setResponseMessage("Compte docteur créé avec succès !");
      setTimeout(() => navigate("/admin/dashboard/account/doctor"), 1500);
    } catch (err: any) {
      console.error("Error details:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers
      });

      if (err.response?.status === 403) {
        // Vérifier si le token a expiré
        const token = localStorage.getItem("token");
        if (token) {
          const tokenData = JSON.parse(atob(token.split('.')[1]));
          const isExpired = tokenData.exp * 1000 < Date.now();
          if (isExpired) {
            setResponseMessage("Votre session a expiré. Veuillez vous reconnecter.");
            localStorage.removeItem("token");
            setTimeout(() => navigate("/login"), 2000);
            return;
          }
        }
        setResponseMessage("Accès refusé. Vous n'avez pas les autorisations nécessaires pour effectuer cette action.");
      } else {
        setResponseMessage("Erreur lors de la création du compte docteur.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <DoctorFormBase
        mode="create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      {responseMessage && (
        <ResponseMessage message={responseMessage} role="admin" />
      )}
    </div>
  );
};

export default DoctorAccountRegistration;
